import { createRouter, createWebHistory, RouteRecordRaw } from 'vue-router'
import EventsList from '../views/EventsList.vue'

const routePrefix = process.env.BASE_URL || '/'

const routes: Array<RouteRecordRaw> = [
	{
		path: routePrefix,
		name: 'home',
		component: EventsList
	},
	{
		path: routePrefix + 'whats-on/',
		name: 'events',
		component: EventsList
	},
	{
		path: routePrefix + "wp-admin/:catchAll(.*)",
		name: 'page',
		component: EventsList
	},
	{
		path: routePrefix + ":catchAll(.*)",
		name: '404',
		component: () => import(/* webpackChunkName: "404" */ '../views/ErrorPage404.vue')
	}
	// Single Post Type routes added dynamically in /src/views/EventsList.vue
]

const router = createRouter({
	history: createWebHistory(),
	routes
})

export default router
